import React, { useEffect, useRef } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import AuthPage from "../../views/Auth";
import Private from "../../views/Private";
import { Amplify } from "aws-amplify";
import { useAuthStore } from "./../../store/auth.store"
import Fallback from "../../views/Fallback";
import { toast } from "react-toastify";
import {
  captureMarketplaceReturnUrl,
  continueMarketplaceInstall,
  MARKETPLACE_RETURN_URL_PARAM,
  MARKETPLACE_WIZARD_STATE,
} from "../../services/marketplace-install";
// const Login = lazy(() => import("../../views/Login"));

// Init Cognito
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID || "",
      userPoolClientId: process.env.REACT_APP_AWS_COGNITO_APP_CLIENT_ID || "",
    },
  },
});

export function AppRoutes() {
  const is_logged = useAuthStore((store) => store.user)
  const location = useLocation();
  const navigate = useNavigate();
  const continuationStarted = useRef(false);
  const wasLoggedInOnEntry = useRef(Boolean(is_logged));
  const marketplaceReturnUrl = new URLSearchParams(location.search).get(MARKETPLACE_RETURN_URL_PARAM);
  const shouldContinueMarketplaceInstall = Boolean(wasLoggedInOnEntry.current && marketplaceReturnUrl);

  useEffect(() => {
    if (!shouldContinueMarketplaceInstall || continuationStarted.current) return;

    continuationStarted.current = true;
    captureMarketplaceReturnUrl(location.search);
    continueMarketplaceInstall()
      .then((wizardUrl) => {
        if (wizardUrl) navigate(wizardUrl, { replace: true, state: MARKETPLACE_WIZARD_STATE });
      })
      .catch(() => {
        toast("Unable to continue the HubSpot installation. Please try again from the Marketplace.", { type: "error" });
        navigate("/installations", { replace: true });
      });
  }, [location.search, navigate, shouldContinueMarketplaceInstall]);

  if (shouldContinueMarketplaceInstall) return <Fallback />;

  return (
    <Routes>
      {is_logged ? (
        <>
          <Route path='/*' element={<Private />} />
          <Route index element={<Navigate to='/installations' />} />
          <Route path='auth/*' element={<Navigate to='/installations' />} />
        </>
      ) : (
        <>
          <Route path='auth/*' element={<AuthPage />} />
          <Route path='*' element={<Navigate to='/auth' />} />
        </>
      )}
    </Routes>
  );
}

export default function RouterApp() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}
